import { buildUrlFromSlug } from "./buildUrlFromSlug";

interface GenerateLinkFromSiteUrlReference {
  /** Link likely something like www.google.com, but could also be a relative path depending on implementation */
  link?: string;
  /** Reference to site url document */
  internalSiteUrlReference?: {
    _ref: string;
    _type: "reference";
    isStaticPage?: boolean;
    _id: string;
    page?: {
      _id: string;
      _type: string;
      contentHubArticleContent?: {
        articleGroup?: { parent?: "resources" | "journal" };
      };
    };
    slug: { current: string };
  };
  hash?: string;
  /** Optional Query String  */
  queryParamString?: string;
}

export const generateUrlFromReference = ({
  link,
  internalSiteUrlReference,
  hash,
  queryParamString,
}: GenerateLinkFromSiteUrlReference) => {
  if (link) return link;
  if (internalSiteUrlReference) {
    const pageType = internalSiteUrlReference.isStaticPage
      ? "staticUrl"
      : internalSiteUrlReference?.page?._type;

    if (!pageType) return "";
    let slug = buildUrlFromSlug({
      pageType,
      slug: internalSiteUrlReference?.slug.current,
      parent:
        internalSiteUrlReference?.page?.contentHubArticleContent?.articleGroup
          ?.parent,
    });
    if (queryParamString) {
      slug = `${slug}?${queryParamString}`;
    }
    if (hash) {
      slug = `${slug}#${hash}`;
    }
    return slug;
  }
  return "";
};
